













































































import { Component, Prop, Vue } from "vue-property-decorator";

import { TemplateCategory } from "@/data/templateCategory/templateCategory";
import { TemplateColor } from "@/data/templateColor/templateColor";

import UnDraggableTree from "./unDraggableTree/unDraggableTree.vue"
import TemplateColorView from "./templateColorView/templateColorView.vue"
import * as Enumerable from "linq-es5";

import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";

import SearchGlass from "../resources/searchGlass.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";

const isElement = (x: any): x is HTMLInputElement =>
  x instanceof HTMLInputElement;

import * as def from "@/definitions";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
    SearchGlass,
    CheckBoxOn,
    UnDraggableTree,
    TemplateColorView,
    DropdownList
  }
})
export default class LeftController extends Vue {
  @Prop()
  private templateCategoryList!: TemplateCategory[];
  @Prop()
  private selectedTemplateCategory!: TemplateCategory;
  @Prop()
  private templateColorList!: TemplateColor[];
  @Prop()
  private selectedTemplateColor!: TemplateColor;

  @Prop()
  private searchSelection!: any[];
  @Prop()
  private displayResembles!: any[];

  private inputFocused: boolean = false;

  get categories(): TemplateCategory[] {
    return this.templateCategoryList;
  }

  createSearchSelection(value) {
    this.inputFocused = true;
    // if (value != "") {
    this.$emit("createSearchSelection", value);
    // }
  }

  get searchSelectionItems(): any[] {
    return this.searchSelection;
  }

  get selectedSelectionItem() {
    return Enumerable.asEnumerable(this.searchSelectionItems)
      .Where(x => x.isSelected)
      .ToArray()[0];
  }

  select(templateCategoryInformation: {
    id: number;
    hierarchy: number;
    name: string;
  }) {
    this.$emit(
      "selectTemplateCategory",
      templateCategoryInformation.id,
      templateCategoryInformation.hierarchy
    );
    this.onblur();
    if (!isElement(this.$refs.input)) return;

    //本当はこれをしたくないけどこれでしかできない
    this.$refs.input.value = templateCategoryInformation.name;
  }

  putFocus() {
    if (!isElement(this.$refs.input)) return;
    this.$refs.input.focus();
  }

  resetInput() {
    if (!isElement(this.$refs.input)) return;
    this.$refs.input.value = "";
  }

  onblur() {
    this.$nextTick(() => {
      this.inputFocused = false;
    });
  }

  changeDisplayResembles() {
    this.$emit("changeDisplayResembles");
  }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    selectTemplateColor(templateColor , release = false){
        if(release){
            templateColor = new TemplateColor()
        }
        this.$emit("selectTemplateColor" , templateColor)
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }

    unDraggableTreeLog(parameter){
        this.$emit("unDraggableTreeLog", parameter);
    }
}
